import React from 'react';
import { get, post, put, del } from '../../../Utility/Http';
import { chatHistoryListGet, followUpGet, followUpPostGet } from '../Model/ChatHistoryModel';
import Config from '../../../Utility/Config';


export const chatHistoryList = (data) => {
    return get(`${Config.extendedUrl}chat_history/list`, data).then((response) => {
        return chatHistoryListGet(response)
    })
};


export const followUp = (data) => {
    return get(`${Config.extendedUrl}followup`, data).then((response) => {
        return followUpGet(response)
    })
};

export const followUpPost = (data) => {
    return post(`${Config.extendedUrl}followup`, data).then((response) => {
        return followUpPostGet(response)
    })
};

